import { checkIsAuthenticated,redirectIf2faEnabled,redirectIf2faDisabled } from '@template/utils'

const TwoFaModule = () => import(/* webpackChunkName: "2fa-module" */ './view/Module.vue');
const SetupAuth = () => import(/* webpackChunkName: "setup-auth" */ './view/SetupAuth.vue');
const GoogleSetup = () => import(/* webpackChunkName: "google-setup" */ './view/GoogleSetup.vue');
const GoogleVerifyOtp = () => import(/* webpackChunkName: "google-verify-otp" */ './view/GoogleVerifyOtp.vue');
const EditDashboard = () => import(/* webpackChunkName: "edit-2fa" */ './view/EditDashboard.vue');
const VerifyExistingOtp = () => import(/* webpackChunkName: "verify-existing-otp" */ './view/VerifyExistingOtp.vue');


const TwoFaRoutes = {
    path:      '/2fa',
    component: TwoFaModule,
    children: [
        {
            path:      'setup-auth',
            name:      'TwoFASetupAuth',
            component: SetupAuth,
            beforeEnter: checkIsAuthenticated
        },
        {
            path:      'google/setup',
            name:      'TwoFaGoogleSetup',
            component: GoogleSetup,
            beforeEnter: redirectIf2faEnabled
        },
        {
            path:      'google/verify',
            name:      'TwoFaGoogleVerifyOtp',
            component: GoogleVerifyOtp,
            beforeEnter: redirectIf2faEnabled
        },
        {
            path:      'edit-2fa',
            name:      'TwoFaEdit',
            component: EditDashboard,
            beforeEnter : redirectIf2faDisabled
        },
        {
            path:      'edit/verify/otp',
            name:      'TwoFaVerifyExistingOtp',
            component: VerifyExistingOtp,
            beforeEnter : redirectIf2faDisabled
        }
    ]
};

export default TwoFaRoutes;